import { Button, InputBase, TextField } from '@mui/material';
import { styled } from '@mui/system';

const StyleTextField = styled(TextField)(({ theme }) => ({
    '& label.Mui-focused': {
        color: '#1A1B1D'
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: '#1A1B1D'
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#1A1B1D'
        },
        '&:hover fieldset': {
            borderColor: '#1A1B1D'
        },
        '& .Mui-focused fieldset': {
            borderColor: '#1A1B1D'
        },
        borderRadius: '10px'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#ffffff'
    }
}));

const SearchText = styled(TextField)(({ theme }) => ({
    '& label.Mui-focused': {
        color: '#ffffff'
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: '#ffffff'
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#ffffff'
        },
        '&:hover fieldset': {
            borderColor: '#ffffff'
        },
        '& .Mui-focused fieldset': {
            borderColor: '#ffffff'
        },
        paddingLeft: '8px',
        borderRadius: '10px'
    },
    '& .MuiInputBase-input': {
        padding: '10px 10px 10px 0px',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.7rem',
        fontWeight: 700
    },
    '& .MuiInputAdornment-root': {
        margin: 0
    }
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3)
    },
    '& .MuiInputBase-input': {
        width: '300px',
        height: '48px',
        borderRadius: '10px',
        position: 'relative',
        backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#2b2b2b',
        border: '2px solid #e8e8e8',
        fontSize: '0.7rem',
        lineHeight: '20px',
        padding: '0 16px',
        transition: 'border-color 0.15s ease-in-out 0s',
        fontFamily: ['DM Sans', 'sans-serif'].join(','),
        '&:focus': {
            borderColor: '#1A1B1D'
        }
    }
}));

const SaveButton = styled(Button)(({ theme }) => ({
    borderRadius: '10px',
    height: '48px',
    textTransform: 'capitalize',
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: 600,
    fontSize: '0.7rem',
    backgroundColor: '#17375E',
    color: '#ffffff',
    '&:disabled': { backgroundColor: '#e8e8e8' },
    '&:hover': { backgroundColor: '#5C738E' }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
        }
    }
};

const ActionData = {
    All: { action_id: null, action_type_id: null, action_result_id: null },
    YellowCard: { action_id: null, action_type_id: '9', action_result_id: null },
    RedCard: { action_id: null, action_type_id: '10', action_result_id: null },
    GoalKick: { action_id: '1', action_type_id: null, action_result_id: null },
    Shot: { action_id: '1', action_type_id: null, action_result_id: null }, // Alias for GoalKick
    GoalOpportunity: { action_id: '1', action_type_id: null, action_result_id: '1' },
    ShotOnTarget: { action_id: '1', action_type_id: null, action_result_id: '1,3' }, // Shots on target = saved (1) + goal (3)
    ShotOffTarget: { action_id: '1', action_type_id: null, action_result_id: '2,7,19' }, // Off Target (2) + Blocked (7) + Deflected (19)
    Goal: { action_id: '1', action_type_id: null, action_result_id: '3' },
    PenaltyMissed: { action_id: '1', action_type_id: '13', action_result_id: '1,2' },
    FreeKick: { action_id: '1,2,3', action_type_id: '11,13', action_result_id: null },
    FreeKickPass: { action_id: '2', action_type_id: '11', action_result_id: null }, // Passes from free kicks only
    Passes: { action_id: '2', action_type_id: null, action_result_id: null },
    Pass: { action_id: '2', action_type_id: null, action_result_id: null }, // Alias for Passes
    Assist: { action_id: '9', action_type_id: null, action_result_id: null }, // Action ID 9 = Assist
    ShortPass: { action_id: '2', action_type_id: '4', action_result_id: null },
    LongPass: { action_id: '2', action_type_id: '5', action_result_id: null },
    LongPassSuccess: { action_id: '2', action_type_id: '5', action_result_id: '4' },
    PassesSuccess: { action_id: '2', action_type_id: null, action_result_id: '4' },
    ThroughPass: { action_id: '2', action_type_id: '6', action_result_id: null },
    KeyPass: { action_id: '2', action_type_id: '7', action_result_id: null },
    PassesShots: { action_id: '2', action_type_id: '15', action_result_id: null },
    Corner: { action_id: '2,3', action_type_id: '12', action_result_id: null },
    BuildUp: { action_id: '2,4', action_type_id: null, action_result_id: null },
    Turnover: { action_id: null, action_type_id: null, action_result_id: '5,11,12,15' }, // Bad Pass (5), Stolen (11), Intercepted (12), Offside (15)
    TurnoverOffensive: { action_id: null, action_type_id: null, action_result_id: '5,11,12,15', court_area: '1,2' }, // Same as Turnover but in offensive court
    TurnoverDefensive: { action_id: null, action_type_id: null, action_result_id: '5,11,12,15', court_area: '3,4' }, // Same as Turnover but in defensive court
    Cross: { action_id: '3', action_type_id: null, action_result_id: null, excludeActionTypeId: 12 }, // Exclude corners (action_type_id=12)
    CrossSuccess: { action_id: '3', action_type_id: null, action_result_id: '4,8', excludeActionTypeId: 12 }, // Exclude corners
    Dribble: { action_id: '4', action_type_id: null, action_result_id: null },
    DribbleSuccess: { action_id: '4', action_type_id: null, action_result_id: '4' },
    Penalty: { action_id: '1', action_type_id: '13', action_result_id: null },
    Foul: { action_id: '5', action_type_id: null, action_result_id: null },
    DrawFoul: { action_id: '6', action_type_id: null, action_result_id: null },
    Offside: { action_id: null, action_type_id: null, action_result_id: '15' },
    Saved: { action_id: '8', action_type_id: null, action_result_id: null },
    Interception: { action_id: '10', action_type_id: null, action_result_id: null },
    InterceptionOffensive: { action_id: '10', action_type_id: null, action_result_id: null, court_area: '1,2' },
    InterceptionDefensive: { action_id: '10', action_type_id: null, action_result_id: null, court_area: '3,4' },
    Clearance: { action_id: '11', action_type_id: null, action_result_id: null },
    Tackle: { action_id: '12', action_type_id: null, action_result_id: null },
    TackleOffensive: { action_id: '12', action_type_id: null, action_result_id: null, court_area: '1,2' },
    TackleDefensive: { action_id: '12', action_type_id: null, action_result_id: null, court_area: '3,4' },
    Blocked: { action_id: '13', action_type_id: null, action_result_id: null },
    SuperSaved: { action_id: '17', action_type_id: null, action_result_id: null },
    AirChallenge: { action_id: '18', action_type_id: null, action_result_id: null },
    GroundChallenge: { action_id: '19', action_type_id: null, action_result_id: null },
    ThrowIn: { action_id: '2', action_type_id: '14', action_result_id: null },
    One: { action_id: '20', action_type_id: null, action_result_id: null },
    GoalReceive: { action_id: '22', action_type_id: null, action_result_id: null },
    Exits: { action_id: '5,6,10,11,12,13,14,15,20', action_type_id: null, action_result_id: null },
    // Opponent action mappings - match the stats calculation in s4u_new_get_players_stats_summary_filtered_complete
    // These are used for getting opponent video clips that match the displayed stats
    // The SQL function s4u_new_get_opponent_tags handles special filtering:
    // - Crosses: excludes corners (action_type_id=12) when action_id=3
    // - Free kicks: only includes shots (action_id=1) when action_type_id IN (11,13)
    OpponentCross: { action_id: '3', action_type_id: null, action_result_id: null }, // Crosses excluding corners
    OpponentCorner: { action_id: null, action_type_id: '12', action_result_id: null }, // Corners only (by action_type)
    OpponentFreeKick: { action_id: null, action_type_id: '11,13', action_result_id: null } // Free kick shots (SQL filters for action_id=1)
};

// Offensive action ids that can produce a turnover: Pass (2), Dribble (4), Turnover (7).
// Used to scope the clip fetch so defensive actions (Interception=10, Tackle=12,
// Clearance=11, etc.) are never returned, even if they share a result code.
const TURNOVER_ACTION_IDS = '2,4,7';

// A turnover is an OFFENSIVE loss of possession. Mirrors the total_turnovers definition
// in s4u_new_get_players_stats_summary_filtered_complete:
//   action 7 (turnover) | bad pass (action 2, result 5/11/12) | bad dribble (action 4, result != 4) | offside (result 15)
// Explicitly excludes defensive actions like Interception even when they carry result 11/12.
const isOffensiveTurnoverTag = (tag) => {
    const a = Number(tag.action_id);
    const r = Number(tag.action_result_id);
    return a === 7 || (a === 2 && [5, 11, 12].includes(r)) || (a === 4 && r !== 4) || r === 15;
};

// A goal is a SHOT (action 1) whose result is Goal (3). Note: assists are also
// tagged with result Goal (3), so filtering by result alone would wrongly include
// them — the action_id = 1 constraint is what keeps goal clips to shots only.
const isGoalTag = (tag) => Number(tag.action_id) === 1 && Number(tag.action_result_id) === 3;

// Maps Overview tag button names to ActionData keys for unified API calls
const TagToActionData = {
    'Goals': 'Goal',
    'Chances': 'Shot',
    'Free Kicks': 'FreeKick',
    'Corners': 'Corner',
    'Crosses': 'Cross',
    'Draw Fouls': 'DrawFoul',
    'Turnovers': 'Turnover',
    'Offsides': 'Offside',
    'Penalties Gained': 'Penalty',
    'Saved': 'Saved',
    'Blocked': 'Blocked',
    'Clearance': 'Clearance'
    // 'Started From Interception', 'Started From Tackle', 'Started From Throw In'
    // use dedicated possession-based functions, not simple action filters
};

/**
 * Normalize tag data for export dialogs and video player
 * Handles different field naming conventions from various API endpoints
 */
const normalizeTagData = (data, options = {}) => {
    const { teamId } = options;
    return data.map((item) => {
        // Calculate time_in_game from start_time if not present
        // time_in_game should be an integer representing game minutes
        let timeInGame = item.time_in_game;
        const startTime = item.player_tag_start_time || item.team_tag_start_time || item.start_time;

        // Calculate from start_time if time_in_game is not a valid number
        if (timeInGame === undefined || timeInGame === null || timeInGame === '') {
            if (startTime && typeof startTime === 'string') {
                const parts = startTime.split(':');
                if (parts.length >= 2) {
                    // For HH:MM:SS format: hours * 60 + minutes = game minutes
                    const hours = parseInt(parts[0], 10) || 0;
                    const minutes = parseInt(parts[1], 10) || 0;
                    timeInGame = hours * 60 + minutes;
                }
            }
        }

        // Ensure time_in_game is always a valid integer (default to 0 if invalid)
        let normalizedTimeInGame = parseInt(timeInGame, 10);
        if (isNaN(normalizedTimeInGame)) {
            normalizedTimeInGame = 0;
        }

        return {
            ...item,
            // Timing fields
            time_in_game: normalizedTimeInGame,
            start_time: item.team_tag_start_time || item.player_tag_start_time || item.start_time,
            end_time: item.team_tag_end_time || item.player_tag_end_time || item.end_time,
            player_tag_start_time: item.player_tag_start_time || item.team_tag_start_time || item.start_time,
            player_tag_end_time: item.player_tag_end_time || item.team_tag_end_time || item.end_time,
            team_tag_start_time: item.team_tag_start_time || item.player_tag_start_time || item.start_time,
            team_tag_end_time: item.team_tag_end_time || item.player_tag_end_time || item.end_time,
            // Player and action fields (normalize singular/plural)
            player_name: item.player_names || item.player_name || item.full_name || '',
            player_names: item.player_names || item.player_name || item.full_name || '',
            action_name: item.action_names || item.action_name || '',
            action_names: item.action_names || item.action_name || '',
            action_type: item.action_type_names || item.action_type_name || item.action_type || '',
            action_type_names: item.action_type_names || item.action_type_name || '',
            action_result: item.action_result_names || item.action_result_name || item.action_result || '',
            action_result_names: item.action_result_names || item.action_result_name || '',
            // Game info
            game_id: Number(item.game_id),
            team_id: teamId || item.team_id,
            period: item.period
        };
    });
};

export { StyleTextField, BootstrapInput, SearchText, SaveButton, MenuProps, ActionData, TagToActionData, normalizeTagData, TURNOVER_ACTION_IDS, isOffensiveTurnoverTag, isGoalTag };
